import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import AccountsDropdown from './AccountsDropdownComponent';
import { logout } from 'apex-web/lib/redux/actions/authActions';
import { selectAccount } from 'apex-web/lib/redux/actions/userActions';
import {
  notMarginAccountsSelector,
  marginAccountSelector,
  defaultAccountSelector
} from 'apex-web/lib/redux/selectors/marginSelectors';
import { RETIREMENT_ACCOUNT_SUFFIX } from '../../constants';

const mapStateToProps = state => {
  const { selectedAccountId } = state.user;
  const marginAccount = marginAccountSelector(state);
  const accounts = notMarginAccountsSelector(state);
  let selectedAccount = accounts.find(
    account => account.AccountId === selectedAccountId
  );

  const tradingAccountId = defaultAccountSelector(state)?.AccountId;
  const retirementAccountId = accounts.find(account =>
    account.AccountName.endsWith(RETIREMENT_ACCOUNT_SUFFIX)
  )?.AccountId;

  if (!selectedAccount && marginAccount) {
    selectedAccount = defaultAccountSelector(state);
  }

  return {
    accounts,
    selectedAccount,
    tradingAccountId,
    retirementAccountId
  };
};

const mapDispatchToProps = {
  logout,
  selectAccount
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(AccountsDropdown));
